import { Box, Stack, Typography } from "@mui/material";
import { icons } from "assets/AssetHelper";
import { useThemePalette } from "common/hooks/theme_palette";
import { useTranslation } from "react-i18next";
import GetDirection from "components/Atoms/SharedComponents/Orders/getDirection";
import { openGoogleMaps } from "services/modules/utils/Helper";

export default function LocationCard({ data, step }) {
  const { t } = useTranslation();
  const isFulfillment = data?.name?.toLowerCase()?.includes("fulfillment");
  const isStore =
    data?.name?.toLowerCase()?.includes("location") &&
    !data?.name?.toLowerCase()?.includes("customer");

  const locationInfo = {
    [!isStore ? t("orders.customer_name") : t("orders.store_name")]: !isStore
      ? data?.customerInfo?.name
      : data?.destination?.store?.name,
    [t("orders.phone_number")]: !isStore
      ? data?.customerInfo?.mobile
      : `+(${data?.destination?.store?.details?.country_code}) ${data?.destination?.store?.details?.phone_number}`,
    [t("orders.address")]: !isStore
      ? data?.customerInfo?.address
      : data?.destination?.detailed_address || t("orders.no_address_available"),
  };
  return (
    <Stack sx={{ width: { xs: "100%", md: "47%" } }} gap={3}>
      <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "flex-start", sm: "center" }} gap={{ xs: 1.5, sm: 3 }}>
        <Stack direction={"row"} alignItems="center">
          <Box
            component="img"
            src={icons.locationOutlined}
            width="24px"
            height="24px"
            pr="4px"
          />
          <Typography fontSize={{ xs: "15px", sm: "16px" }}>{data?.name}</Typography>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{
            background:
              data?.status === "pending"
                ? "rgba(255, 204, 0, 0.10)"
                : "#E1F5E8",
            width: "111px",
            height: "40px",
          }}
        >
          <Typography
            sx={{
              color: data?.status === "pending" ? "#EAB308" : "#29B95F",
              fontWeight: "500",
              fontSize: "18px",
              textTransform: "capitalize",
            }}
          >
            {data?.status === "completed"
              ? data?.isLastLocation
                ? t("orders.delivered")
                : t("orders.collected")
              : t("orders.pending")}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        justifyContent="space-between"
        sx={{
          border: "1px solid black",
          borderRadius: "6px",
          p: 2,
          backgroundColor: "#F8F8F8",
          height: "100%",
          minHeight: "140px",
        }}
      >
        {isFulfillment ? (
          <Stack
            direction="row"
            alignItems="center"
            gap={3}
            sx={{ height: "100%" }}
          >
            <Box component="img" src={icons.boxes} width="96px" />
            <Typography sx={{ fontSize: { xs: "20px", sm: "28px" }, fontWeight: "400" }}>
              {data?.destination?.name} {t("orders.cadeau_fulfilment_center")}
            </Typography>
          </Stack>
        ) : (
          Object.keys(locationInfo).map((key, i) => (
            <Stack key={i} direction="row" justifyContent="space-between" gap={1.5}>
              <Typography
                sx={{ width: { xs: "35%", sm: "25%", md: "20%" }, color: "#969696", fontWeight: "400" }}
              >
                {key}
              </Typography>
              <Stack
                direction="row"
                sx={{ width: { xs: "62%", sm: "72%", md: "77%" } }}
                gap="5px"
                alignItems={"center"}
              >
                <Typography sx={{ fontWeight: "400", fontSize: "12px" }}>
                  {key === t("orders.address") ? (
                    <>
                      {data?.destination?.lat && data?.destination?.long && (
                        <GetDirection
                          address={locationInfo?.[key]}
                          lat={data?.destination?.lat}
                          long={data?.destination?.long}
                        />
                      )}
                    </>
                  ) : (
                    <Typography fontSize={{ xs: "13px", sm: "15px" }}>{locationInfo[key]}</Typography>
                  )}
                </Typography>
              </Stack>
            </Stack>
          ))
        )}
      </Stack>
    </Stack>
  );
}
